var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.97489 11.6629L18.5293 0.300031C18.7281 0.104259 18.9608 0.00429032 19.2274 0.000124961C19.4941 -0.0040404 19.7311 0.095928 19.9387 0.300031C20.1462 0.504133 20.25 0.738489 20.25 1.0031C20.25 1.26793 20.1462 1.50239 19.9387 1.70649L7.82122 13.6435C7.57934 13.8812 7.29723 14 6.97489 14C6.65254 14 6.37043 13.8812 6.12856 13.6435L0.544313 8.15184C0.345465 7.95607 0.247378 7.72368 0.250053 7.45469C0.252505 7.18591 0.357502 6.94947 0.565045 6.74537C0.772587 6.54127 1.01089 6.43922 1.27996 6.43922C1.54925 6.43922 1.78767 6.54127 1.99521 6.74537L6.97489 11.6629Z",
    fill: "#10B981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.cd4d2cf850aeb8d8d672c4e294a454cb.svg";
export { ForwardRef as ReactComponent };